<script setup>
import {ref, watch, defineProps, defineEmits} from "vue"

const props = defineProps({
  modelValue: {type: Object, required: true},
  loading: {type: Boolean, default: false}
})

const emit = defineEmits(["update:modelValue", "save", "cancel"])

const localForm = ref({...props.modelValue})
const isFormValid = ref(false)

watch(
    () => props.modelValue,
    (newVal) => {
      if (JSON.stringify(newVal) !== JSON.stringify(localForm.value)) {
        localForm.value = {...newVal}
      }
    },
    {deep: true}
)

const formRef = ref(null)

const requiredRule = (v) => !!v || "This field is required"
const differentCabRule = () =>
    localForm.value.isdnCab1 !== localForm.value.isdnCab2 ||
    "ISDN Cab1 and ISDN Cab2 must be different"

const schema = [
  {type: "text", model: "trainSetId", label: "Train Set Id", rules: [requiredRule]},
  {type: "text", model: "isdnCab1", label: "ISDN Cab1", rules: [requiredRule, differentCabRule]},
  {type: "text", model: "isdnCab2", label: "ISDN Cab2", rules: [requiredRule, differentCabRule]}
]

function submitForm() {
  if (formRef.value.validate()) {
    emit("save", localForm.value)
  }
}
</script>

<template>
  <v-form ref="formRef" v-model="isFormValid">
    <template v-for="field in schema" :key="field.model">
      <v-text-field
          v-model="localForm[field.model]"
          :disabled="props.loading"
          :label="field.label"
          :rules="field.rules"
          required
      />
    </template>

    <v-divider class="my-3"/>

    <div class="d-flex justify-end">
      <v-btn :disabled="props.loading" variant="plain" @click="emit('cancel')">
        Close
      </v-btn>

      <v-btn
          :disabled="props.loading || !isFormValid"
          class="ml-2"
          color="primary"
          variant="tonal"
          @click="submitForm"
      >
        <span v-if="props.loading">Saving...</span>
        <span v-else>Create</span>
      </v-btn>
    </div>
  </v-form>
</template>
